import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import anime from 'animejs';

import dataModel from '../../models/DataModel';
import PageStateDAO from '../../dao/PageStateDAO';
import { PageNames } from '../../constants/ReduxConstants';

import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';

import Animate from '../Animate';
import BaseComponent from '../../baseClasses/BaseComponent'; 
import DashboardProjectCard from '../DashboardProjectCard';
import DashboardMetricCard from '../DashboardMetricCard';
import HandsFreeButton from '../HandsFreeButton';

import searchIcon from '../../assets/images/search-icon.svg';
import closeIcon from '../../assets/images/close-circle-icon.svg';
import LoadingDots from '../../components/LoadingDots';
import companySelectIcon from '../../assets/images/caret-white.svg';
import projectsIcon from '../../assets/images/projects-icon-gray.svg';
import { project_root, complete_project_root_mobile } from  '../../dao/ProjectsDAO';
import i18n from '../../i18n';

import toggle from '../../assets/images/ao-toggle-on.png';
import './UserDashboard.scss';
import Input from '../Input';

// This component serves as the mobile dashboard / landing page
export class UserDashboard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      startScroll: 0,
      endScroll: 0,
      displayedPage: 1,
      searchMargin: 16,
      searchString: '',
      marginLeft: 10,
      filteredCompanies: [],
      currentCompanyId: 0,
    };
    this.companySelect = false;

    this.handleMakeFavorite = this.handleMakeFavorite.bind(this);
    this.handleRemoveFavorite = this.handleRemoveFavorite.bind(this);
    this.showCompanySelect = this.showCompanySelect.bind(this);
    this.handleCompanySelect = this.handleCompanySelect.bind(this);

    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  componentDidMount() {
    this.projectCaptionHasOverflow = this.project_caption.offsetHeight < this.project_caption.scrollHeight ||
      this.project_caption.offsetWidth < this.project_caption.scrollWidth;
    this.projectWidth = (dataModel.mobileBridge.isMobile) ? (window.innerWidth - 16) : 930;

    delete localStorage.scrollPositionTasks;
    delete localStorage.scrollPositionCompletionStep;
    delete localStorage.scrollPosition;
    if (this.props.projects) {
      this.setState({
        displayedPage: 1,
        totalPages: this.props.projects.count
          ? Math.ceil(this.props.projects.count / (this.props.projects.perPage ? this.props.projects.perPage : 1))
          : 0,
      });
    }
    this.setFilteredCompanies();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetPaging != this.props.resetPaging || prevProps.projects != this.props.projects) {
      this.setState({
        displayedPage: 1,
        totalPages: this.props.projects.count
          ? Math.ceil(this.props.projects.count / (this.props.projects.perPage ? this.props.projects.perPage : 1))
          : 0,
      });
      if (this.scroller && this.props.resetPaging){
        this.scroller.scrollTo(0, 0);
        this.infiniteDone = false;
        this.setState({ loadingMore: false, hasScrolled: false });
        this.scrollinProgress = false;
      }
    }
    if (prevProps.currentUser != this.props.currentUser) {
      this.setFilteredCompanies();
    }
  }

  setFilteredCompanies() {
    if (this.props.companies) {
      let filteredCompanies = [];
      if (this.props.isSuperUser) {
        filteredCompanies = this.props.companies.map(company => {
          return company;
        });
      } else if (this.props.currentUser && this.props.currentUser.vendor_companies && this.props.currentUser.vendor_companies.length > 0){
        filteredCompanies = this.props.currentUser.vendor_companies.map(
          company => {
            return company;
          }
        );
        filteredCompanies.push(this.props.currentUser.companies[0]);
      }
      filteredCompanies.sort((a, b) => (a.name < b.name) ? -1 : 1);
      this.setState({ currentCompanyId: this.props.currentCompany.id, filteredCompanies });
    }
  }

  handleBackgroundClick() {
    this.collapseCompanySelect();
  }

  handleClose() {
    if (this.props.closePopup) {
      this.props.closePopup();
    }
  }

  handleFinishedAnimation() {
    this.setState({ animate: false });
    if (this.animatePageDown) {
      delete this.animatePageDown;
    }
    else if (this.animatePageUp) {
      delete this.animatePageUp;
    }
  }

  handleProjectClick(project) {
    if (this.companySelect) {
      this.collapseCompanySelect();
      return;
    }
    if (!dataModel.mobileBridge.isMobile) {
      dataModel.navigateUri = '/projects/' + project.id;
    }
    else {
      this.analyticsLogger.logDashboardEvent('AllProjectsOverviewProjectDetail');
      localStorage.setItem('is_offline_project',project.is_offline_project==null?false:project.is_offline_project);
      //set the Details tab as selected tab on PageStateDAO
      PageStateDAO.setPageStateEntry(PageNames.MOBILE_PROJECT_DETAIL, 'tabSelected', 'Details');
      this.props.history.push({
        pathname: '/mobile/projects/' + project.id,
        state: { 
          projectName: project.name, 
          projectStatus: project.status,
        },
      });
    }
  }

  handleViewTasks(filter) {
    if (this.companySelect) {
      this.collapseCompanySelect();
      return;
    }
    // log analytics event
    const filterToAnalyticsLabelMap = {
      'not_started': 'AllTasksNotStarted',
      'in_progress': 'AllTasksInProgress',
      'in_review': 'AllTasksInReview',
    };
    this.analyticsLogger.logDashboardEvent(filterToAnalyticsLabelMap[filter]);

    if (dataModel.mobileBridge.isMobile) {
      this.props.history.push('/mobile/projects-tasks/' + filter);
    }
  }

  handleDisplayProjects() {
    if (this.companySelect) {
      this.collapseCompanySelect();
      return;
    }
    if (dataModel.mobileBridge.isMobile) {
      this.analyticsLogger.logDashboardEvent('TotalProjects');
      this.props.history.push('/mobile/projects');
    }  
  }

  handleDisplayLocations() {
    if (this.companySelect) {
      this.collapseCompanySelect();
      return;
    }
    if (dataModel.mobileBridge.isMobile) {
      this.analyticsLogger.logDashboardEvent('MapMyDay');
      this.props.history.push('/mobile/maps/mapMyDay');
    }  
  }

  handleRejectedBanner() {
    if (this.props.taskCounts && this.props.taskCounts.rejected_count) {
      return <div className="rejected-banner">
        <div className="rejected-text">{this.props.taskCounts.rejected_count + ' ' + i18n.tr('user_dashboard:rejected')}</div>
      </div>;
    }
    return null;
  }

  handleSearch() {
    
  }

  handleSearchChange(e) {
    this.setState({ searchString: e.target.value });    
  }

  handleSearchToggle() {
    if (!this.state.displaySearchBar) {
      this.analyticsLogger.logDashboardEvent('SearchIconClick');
      this.setState({ searchString: null, displaySearchBar: true, animateSearchBarIn: true });
    }
    else {
      this.setState({ searchString: '', animateSearchBarOut: true });
    }
    this.handleClearSearch();
  }

  handleSearchAnimateInDone() {
    this.setState({ animateSearchBarIn: false, searchMargin: (window.innerWidth - 24) * -1 });
  }

  handleSearchAnimateOutDone() {
    this.setState({ animateSearchBarOut: false, displaySearchBar: false, searchMargin: 16 });
  }

  handleSearchStringChange(e) {
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }

    const searchString = e.target.value;
    if (!searchString) {
      this.infiniteDone = false;
    }

    this.setState({ searchString: searchString });
    this.searchTimer = setTimeout(() => { 
      this.analyticsLogger.logDashboardEvent('TypingInSearch');
      if (this.props.handleProjectSearch) {
        this.props.handleProjectSearch(searchString);
      }
    }, 400);
  }

  handleClearSearch() {
    this.infiniteDone = false;
    this.setState({ searchString: '' });
    if (this.props.handleProjectSearch) {
      this.props.handleProjectSearch(null);
    }
  }

  async handleRemoveFavorite(e, project_id) {
    e.stopPropagation();
    let project = await dataModel.projectsDAO.getProject(project_id);
    if (project) {
      dataModel.projectsDAO.setFavoriteProject(project_id, false, null, { recordDescriptor: project_root }).then(project => {
        // already done below
      }).catch(error => {
        this.props.handleProjectFavorites(project, true);
      });
      this.analyticsLogger.logDashboardEvent('ProjectDashUnfavorite');
      this.props.handleProjectFavorites(project, false);
    }
  }

  async handleMakeFavorite(e, project_id) {
    e.stopPropagation();
    let project = await dataModel.projectsDAO.getProject(project_id);
    if (project) {
      dataModel.projectsDAO.setFavoriteProject(project_id, true, null, { recordDescriptor: complete_project_root_mobile }).then(project => {
      }).catch(error => {
        this.props.handleProjectFavorites(project, false);
      });
      this.analyticsLogger.logDashboardEvent('ProjectDashFavorite');
      this.props.handleProjectFavorites(project, true);
    }
  }

  handleScrolling() {
    const { projects } = this.props;

    const scrollRect = this.scroller.getBoundingClientRect();
    const listRect = this.list.getBoundingClientRect();

    if (!this.infiniteDone && listRect.right <= (scrollRect.right + 100) && !this.scrollinProgress &&
        projects && projects.ids.length < projects.count) {
      this.scrollinProgress = true;
      this.setState({ loadingMore: true });
      this.props.getNextPage().then(fetchedProjects => {
        if (fetchedProjects && fetchedProjects.ids.length >= projects.count) {
          this.infiniteDone = true;
        }
        this.setState({ loadingMore: false, hasScrolled: true });
        this.scrollinProgress = false;
      });
    }
    
    let margin = Math.max(0, 10 - Math.abs(listRect.left));
    if (listRect.left >= 0 && listRect.left > this.lastLeft) {
      margin = 10;
    }
    this.setState({ marginLeft: margin });
    this.lastLeft = listRect.left;
  }

  showCompanySelect(e) {
    e.stopPropagation();
    if (this.props.allowCompanySelect && this.state.filteredCompanies.length > 1) {
      if (this.companySelect) {
        this.collapseCompanySelect();
      } else {
        this.expandCompanySelect();
      }
    }
  }
  
  handleCompanySelect(e) {
    e.stopPropagation();
    const companyId = parseInt(e.target.dataset.companyId, 10);
    this.setState({ currentCompanyId: companyId }); 
    this.collapseCompanySelect().finished.then(() => {
      if (companyId != this.props.currentCompany.id) {
        this.props.handleCompanySelect(companyId);
      }
    });
  }

  expandCompanySelect() {
    if (!this.companySelect) {
      this.companySelect = true;
      const companyLineHeight = 30;
      const targetHeight = Math.min(this.state.filteredCompanies.length * companyLineHeight, 10 * companyLineHeight);
      return anime({
        targets: '#user-dashboard-company-select-popup',
        height: targetHeight,
        easing: 'easeInOutCubic',
        duration: 300,
      });
    }
  }

  collapseCompanySelect() {
    if (this.companySelect) {
      this.companySelect = false;
      return anime({
        targets: '#user-dashboard-company-select-popup',
        height: '0px',
        easing: 'easeInOutCubic',
        duration: 500,
      });
    }
  }

  render() {

    const { user, projects, taskMetrics } = this.props;
    const { searchString } = this.state;

    if(dataModel.isOffline && projects && projects.projects){
      projects.projects.sort(function(a,b){
        var x = a && a.is_favorite?  a.is_favorite.toString():'';
        var y = b && b.is_favorite?  b.is_favorite.toString():'';
        var aname=a && a.name?  a.name:'';
        var bname=b && b.name?  b.name:'';

        const projectCompare =  y.localeCompare(x);
        if (projectCompare == 0) {
          return aname.toLowerCase().localeCompare(bname.toLowerCase());
        }
        return projectCompare;
      });  
    }
    const popupTitle = !dataModel.mobileBridge.isMobile ? (user.first_name + ' ' + user.last_name + '\'s Report') : (this.props.currentCompany ? this.props.currentCompany.name : '');
    let projectsList = null;
    let numProjects = 0;
    if (projects && projects.projects && projects.projects.length > 0) {
      numProjects = projects.projects.length;
      projectsList = projects.projects.map(project => {
        return <DashboardProjectCard
          key={ project.id }
          project={ project }
          displayFavoriteSelector={true}
          isMobile={ dataModel.mobileBridge.isMobile }
          handleCardClick={ this.handleProjectClick }
          handleRemoveFavorite={ this.handleRemoveFavorite }
          handleMakeFavorite={ this.handleMakeFavorite }
        />;
      });
      if (projectsList.length == 0) {
        numProjects = 0;
        projectsList = <div className="empty-projects">
        <div className="caption">NO PROJECTS FOUND</div>
        <div className="sub-caption">THAT MATCH YOUR SEARCH</div>
      </div>;  
      }
    }
    else {
      numProjects = 0;
      projectsList = <div className="empty-projects">
          <img className="empty-projects__image" src={projectsIcon} alt="empty projects" />
            <p className="empty-projects__description2">Looking for something?</p>
            <p className="empty-projects__description2">Select &#9733; to Favorite a Project and make it available offline.</p>
      </div>;   
    }

    let loadingDots = null;
    if (this.state.loadingMore) {
      loadingDots = <LoadingDots/>;
    }
    
    let currentProjects = numProjects > 0 ?
        <div id={'current-projects'} className={'projects-inner' + (numProjects < projects.perPage ? ' center' : '')}
        ref={element => {
          this.scroller = element;
          if (this.scroller && this.list) {
            this.scroller.addEventListener('scroll', this.handleScrolling);
          }
        }}
        >
          {loadingDots}
          <div className="projects-list" ref={element => {
            this.list = element;
          }}>
            {projectsList}
          </div>
        </div> 
        : <div id={'current-projects'} className={'projects-inner center'}>
            {projectsList}
          </div>;   

    let tasksOverviewDisplay = (
      <div className="tasks-row">
        <div className="tasks-title">{i18n.tr('user_dashboard:tasks')}</div>  
        <div className="tasks-detail-row">
          <div className="task-detail" onClick={(e) => { this.handleViewTasks('not_started'); }}>
            <div className="text-circle">
              <div className="text-circle-text">{this.props.taskCounts ? this.props.taskCounts.not_started_count : 0}</div>  
            </div>
            <div className="task-detail-caption">{i18n.tr('user_dashboard:tasks_not_started')}</div> 
          </div>  
          <hr className="divider"/>
          <div className="task-detail" onClick={(e) => { this.handleViewTasks('in_progress'); }}>
            {this.handleRejectedBanner()}
            <div className="text-circle">
              <div className="text-circle-text">{this.props.taskCounts ? this.props.taskCounts.in_progress_count : 0}</div>
            </div>
            <div className="task-detail-caption">{i18n.tr('user_dashboard:tasks_in_progress')}</div>
          </div>  
          <hr className="divider" />
          <div className="task-detail" onClick={(e) => { this.handleViewTasks('in_review'); }}>
            <div className="text-circle">
              <div className="text-circle-text">{this.props.taskCounts ? this.props.taskCounts.in_review_count : 0}</div>
            </div>
            <div className="task-detail-caption">{i18n.tr('user_dashboard:tasks_in_review')}</div>
          </div>  
        </div>
      </div>
    );

    let mobileBannerHeightAdjustment = false;

    let projectRowHeader = <div id="project-row-header" className="project-row-header">
      <div id="search-slider" className="search-slider" style={{ left: this.state.searchMargin }}>
      <div className="project-row-title">
          <div 
            className={'project-caption' + (this.projectCaptionHasOverflow ? ' project-caption--overflow' : '')}
            ref={el => this.project_caption = el}
          >{i18n.tr('user_dashboard:all_projects_overview')}</div>
        <img className="search-icon" src={searchIcon} alt="search" onClick={this.handleSearchToggle} />
      </div>
      <div className="project-search">
        <div className="search-entry-box">
          <img className="inner-search-icon" src={searchIcon} alt="search" />
          <Input className="search-input" value={searchString || ''} onChange={this.handleSearchStringChange}
              placeholder={i18n.tr('user_dashboard:search_all_projects_overview')} />
          <img className="search-close" src={closeIcon} alt="close" onClick={this.handleClearSearch} />
        </div>
          <div className="search-cancel" onClick={this.handleSearchToggle}>{i18n.tr('user_dashboard:cancel')}</div>
        </div>
        </div>
    </div>;

    let animateSearch = null;
    if (this.state.animateSearchBarIn) {
      animateSearch = <Animate key="animate-search-in" component_id="search-slider"
        duration={500} property={{ left: { startVal: 0, endVal: (window.innerWidth - 24) * -1 } }} completionCallback={this.handleSearchAnimateInDone}/>;
    }
    else if (this.state.animateSearchBarOut) {
      animateSearch = <Animate key="animate-search-out  " component_id="search-slider"
        duration={500} property={{ left: { endVal: 0, startVal: (window.innerWidth - 24) * -1 } }} completionCallback={this.handleSearchAnimateOutDone}/>;
    }

    let companies = []; 
    companies = this.state.filteredCompanies.map(company => {
      let selected = '';
      if (company.id == this.state.currentCompanyId) {
        selected = 'user-dashboard-company-select-item-selected';
      }
      return <div key={company.id} data-company-id={company.id} className={'user-dashboard-company-select-item ' + selected} onClick={this.handleCompanySelect}><div data-company-id={company.id} className="user-dashboard-company-select-item-text">{company.name}</div></div>;
    });

    return (
      <div onClick={this.handleBackgroundClick}>
        <div id="user-dashboard-background" className="user-dashboard-background" onClick={this.handleBackgroundClick}>
        </div>
        <Animate key="animate-open" component_id="user-dashboard" duration={250} property={{ opacity: { startVal: 0, endVal: 1 } }} />
        {this.state.animateClose && (
          <Animate key="animate-close" component_id="user-dashboard" duration={250} property={{ opacity: { startVal: 1, endVal: 0 } }} completionCallback={this.handleClose}/>
        )}

        {this.state.animate && (
          <div>
            <Animate key="animate-current" component_id="current-projects" duration={500} property={{ marginLeft: { startVal: this.state.startScroll, endVal: this.state.endScroll } }} completionCallback={this.handleFinishedAnimation}/>
          </div>  
        )
        }
        <div id="user-dashboard" className={'user-dashboard' + (mobileBannerHeightAdjustment ? ' mobile-height-adjustment' : '')}>
          <div className="close-button" onClick={this.handleBackgroundClick}/>
          <div className="user-dashboard-header">
            <div className="popup-title" onClick={this.showCompanySelect}>{popupTitle}</div>  
            {
              this.props.allowCompanySelect && this.state.filteredCompanies.length > 1 && 
              ( 
                <div className="user-dashboard-company-select" onClick={this.showCompanySelect}>
                  <img className="user-dashboard-company-select-icon" src={companySelectIcon} alt="Select Company" />
                </div> 
              ) 
            }
            <HandsFreeButton />
          </div>
          <div className="content-container">
            {tasksOverviewDisplay}
            {animateSearch}
            {projectRowHeader}
            <div className={'projects-row'} id="projects-row" style={{ marginLeft: this.state.marginLeft }}>
              {currentProjects}
            </div>  
            <DashboardMetricCard
              title={i18n.tr('user_dashboard:tasks_completed')}
              previousMetricValue={taskMetrics ? taskMetrics.completed_tasks.last_week : null}
              currentMetricValue={taskMetrics ? taskMetrics.completed_tasks.this_week : null}
            />
            <DashboardMetricCard
              title={i18n.tr('user_dashboard:task_quality')}
              previousMetricValue={taskMetrics ? taskMetrics.task_quality_percent.last_week: null}
              currentMetricValue={taskMetrics ? taskMetrics.task_quality_percent.this_week: null}
              valueType={'percent'}
            />

          </div>
        </div>  
      <div className="user-dashboard-company-select-popup" id="user-dashboard-company-select-popup"><div className="user-dashboard-company-select-list">{companies}</div></div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
    online: state.main.online,
  };
};

export default withRouter(connect(mapStateToProps)(UserDashboard));



// WEBPACK FOOTER //
// ./src/components/UserDashboard/index.js